import React, { useState } from 'react';
import { Select, Dropdown, Button, Space } from 'antd';
import { GlobalOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { changeLanguage, getSupportedLanguages, getCurrentLanguage } from '../i18n';

const LanguageSelector = ({ type = 'dropdown', size = 'middle' }) => {
  const { t, i18n } = useTranslation();
  const [loading, setLoading] = useState(false);
  
  const supportedLanguages = getSupportedLanguages();
  const currentLanguage = getCurrentLanguage();
  
  const handleLanguageChange = async (languageCode) => {
    setLoading(true);
    try {
      await changeLanguage(languageCode);
    } catch (error) {
      console.error('Failed to change language:', error);
    } finally {
      setLoading(false);
    }
  };
  
  const languageOptions = Object.entries(supportedLanguages).map(([code, info]) => ({
    value: code,
    label: (
      <Space>
        <span>{info.flag}</span>
        <span>{info.nativeName}</span>
      </Space>
    ),
    flag: info.flag,
    name: info.nativeName,
  }));
  
  // Dropdown类型
  if (type === 'dropdown') {
    const items = languageOptions.map(option => ({
      key: option.value,
      label: option.label,
      onClick: () => handleLanguageChange(option.value),
    }));
    
    return (
      <Dropdown
        menu={{ items }}
        placement="bottomRight"
        trigger={['click']}
        disabled={loading}
      >
        <Button
          type="text"
          icon={<GlobalOutlined />}
          size={size}
          loading={loading}
          style={{ 
            color: '#fff',
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.2)',
            borderRadius: '6px',
            padding: '4px 8px',
            height: '32px',
            fontSize: '12px'
          }}
        >
          {currentLanguage.flag} {currentLanguage.nativeName}
        </Button>
      </Dropdown>
    );
  }
  
  // Select类型
  if (type === 'select') {
    return (
      <Select
        value={i18n.language}
        onChange={handleLanguageChange}
        loading={loading}
        size={size}
        style={{ minWidth: 120 }}
        options={languageOptions}
        optionLabelProp="name"
      />
    );
  }
  
  // Button类型
  if (type === 'button') {
    return (
      <Space>
        {languageOptions.map(option => (
          <Button
            key={option.value}
            type={i18n.language === option.value ? 'primary' : 'default'}
            size={size}
            onClick={() => handleLanguageChange(option.value)}
            loading={loading && i18n.language === option.value}
            icon={<span>{option.flag}</span>}
          >
            {option.name}
          </Button>
        ))}
      </Space>
    );
  }
  
  // 默认返回dropdown
  return null;
};

export default LanguageSelector; 